import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { getBIIDTestimonial } from "../lib/api";
import usePageMeta from "../hooks/usePageMeta";

export default function TestimonialBIID() {
  usePageMeta({title:"BIID Leg Paralysis Through Hypnosis - Client Story",description:"A first-person account of achieving permanent wheelchair confinement through consensual hypnotic work with Queen Cleopatra. Includes follow-up interview.",path:"/testimonials/biid"});
  const [data, setData] = useState(null);
  useEffect(() => { getBIIDTestimonial().then(setData); }, []);

  if (!data) {
    return (
      <div data-testid="page-biid" className="py-32 text-center text-cream/60">
        Loading…
      </div>
    );
  }

  return (
    <div data-testid="page-biid">
      <section className="pt-24 md:pt-32 pb-10 max-w-4xl mx-auto px-6 md:px-10 lg:px-16">
        <Link
          to="/testimonials"
          data-testid="biid-back-link"
          className="inline-block eyebrow mb-8 text-cream/60 hover:text-gold transition-colors"
        >
          ← All testimonials
        </Link>
        <div className="eyebrow mb-5 text-gold/80">{data.session_type}</div>
        <h1 className="font-serif text-4xl md:text-6xl text-cream leading-[1.05]">
          {data.title.split("·")[0]}<em className="text-gold">·{data.title.split("·")[1]}</em>
        </h1>
        <p className="mt-6 text-xs uppercase tracking-[0.28em] text-cream/50">
          Shared with consent · Identifying details withheld
        </p>
      </section>

      <section className="max-w-3xl mx-auto px-6 md:px-10 lg:px-16 pb-16">
        <div className="border-l-2 border-gold/40 pl-8 md:pl-10 space-y-6">
          {data.story.map((p, i) => (
            <p
              key={i}
              data-testid={`biid-story-p-${i}`}
              className="font-serif italic text-xl md:text-2xl text-cream/90 leading-relaxed"
            >
              {i === 0 && <span className="text-gold mr-1">“</span>}
              {p}
              {i === data.story.length - 1 && <span className="text-gold ml-1">”</span>}
            </p>
          ))}
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 md:px-10 lg:px-16 pb-24">
        <div className="eyebrow mb-6 text-gold/70">The Follow-Up Interview</div>
        <div className="h-px bg-gold/20 mb-10" />
        <div className="space-y-12">
          {data.interview.map((item, i) => (
            <div key={i} data-testid={`biid-qa-${i}`}>
              <div className="flex gap-4 mb-3">
                <span className="font-serif text-gold text-2xl leading-none">Q.</span>
                <p className="text-cream font-medium leading-snug text-lg">{item.q}</p>
              </div>
              <div className="flex gap-4 pl-2">
                <span className="font-serif text-cream/40 text-2xl leading-none">A.</span>
                <p className="text-cream/75 leading-relaxed">{item.a}</p>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-3xl mx-auto px-6 md:px-10 lg:px-16 pb-32">
        <div className="border-t border-gold/15 pt-10 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <p className="text-sm text-cream/60 max-w-md leading-relaxed">
            BIID (Body Integrity Identity Disorder) work is undertaken only after in-depth
            consultation and with informed, ongoing consent. Every case is unique.
          </p>
          <Link
            to="/book"
            data-testid="biid-book-cta"
            className="inline-block px-8 py-3 bg-gold text-charcoal text-xs uppercase tracking-[0.22em] font-medium hover:bg-cream transition-colors"
          >
            Enquire about a bespoke programme
          </Link>
        </div>
      </section>
    </div>
  );
}
